import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type User } from '@webapp/platform/iam/entities/User'
import messages from './messages'
import { useMutateGrantReportAccessToAllPrimaryCategories } from '../../models/useMutateGrantReportAccessToAllPrimaryCategories'

export const useGrantReportAccessToAllPrimaryCategoriesPresenter = () => {
  const intl = useProcurifyIntl()
  const { grantReportAccessToAllPrimaryCategories, isGranting } =
    useMutateGrantReportAccessToAllPrimaryCategories()

  /**
   * Tenant-wide bulk grant (BHV-023). No confirmation — ADD is
   * non-destructive. Success toast keyed off the resolved promise
   * (201 empty body). Rejects after toasting the error.
   */
  const grantToAllPrimaryCategories = async (user: User): Promise<void> => {
    try {
      await grantReportAccessToAllPrimaryCategories({
        userId: user.id,
      })

      toast.success({
        title: intl.formatMessage(messages.successToastTitle),
        children: intl.formatMessage(messages.successToastMessage, {
          userFullName: user.fullName,
        }),
      })
    } catch (err) {
      toast.error({
        title: intl.formatMessage(messages.errorToastTitle),
        children:
          getMessageFromError(err) ??
          intl.formatMessage(messages.errorToastDefaultMessage),
      })

      throw err
    }
  }

  return {
    commands: {
      grantToAllPrimaryCategories,
    },
    states: {
      isGranting,
    },
  }
}
